import type { GitHubEnvironment } from "./GitHubConnectTab.types"

export const GITHUB_ENVIRONMENT_VALUES: GitHubEnvironment[] = [
  "githubCom",
  "githubCustomDomain"
]

export const DEFAULT_ENVIRONMENT: GitHubEnvironment = "githubCom"
